exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.item-action[data-v-a020df3c] {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/home/superaccess/portal-local-2.0/Superaccess2.0/app/javascript/src/components/admin/authorized/authorized_types/New.vue"],"names":[],"mappings":";AAAA;EACE,gBAAgB;CAAE","file":"New.vue","sourcesContent":[".item-action {\n  cursor: pointer; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-a020df3c","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/javascript/src/components/admin/authorized/authorized_types/New.vue
// module id = 422
// module chunks = 0 1 64 170